// import merge from 'lodash/merge'
import { defineNuxtPlugin } from 'nuxt/app'

// import ru from '~/locales/languages/ru'

const localsMap = {
  'ru-RU': {},
  // 'ru-BY': ruBY(),
  'ru-KZ': {},

  'kk-KZ': {},

  // 'ar-QA': merge({}, ru(), ar(), arQA()),
  // 'en-QA': merge({}, ru(), en(), enQA()),

  // 'ar-SA': merge({}, ru(), ar(), arSA()),
  // 'en-SA': merge({}, ru(), en(), enSA()),
  'ar-SA': {},
  'en-SA': {},

  // для тестирования
  // 'ar-RU': merge({}, ru(), ar()),
  // 'en-RU': merge({}, ru(), en()),
}

export default defineNuxtPlugin(
  ({ $switchLocalePath, $i18n, $dayjs, $gaApp }) => {
    const {
      locale,
      localeProperties,
      // getBrowserLocale,
      getLocaleCookie,
      setLocaleCookie,
    } = $i18n

    // const currentEnvLocale = $config.NODE_LOCALE_ENV

    /**
     * getBrowserLocale определяет приоритетную локаль в настройках браузера из имеющихся в codesByCountry
     * если не находит совпадений, то отдает undefined
     * например, в настройках браузера указаны ru и en, а codesByCountry === ['ar'], то getBrowserLocale() === undefined, поскольку нет совпадений
     */
    // const browserLocale = getBrowserLocale()

    const cookieLocale = getLocaleCookie()

    const { iso: localeAndCountry } = localeProperties.value

    const proposedLocale = locale.value // browserLocale || locale

    // если предлагаемая локаль есть в локалях страны
    if (!cookieLocale) {
      setLocaleCookie(proposedLocale)
    }

    /**
     * слияние значений из файла текущей страны с локалью
     */
    const { locales } = $gaApp.modules

    $i18n.mergeLocaleMessage(locale.value, {
      ...locales[localeAndCountry],
      ...localsMap[localeAndCountry],
    })

    /**
     * установка значений для dayjs
     */
    const dayjsUpdateLocale = (locale) => {
      $dayjs.updateLocale(locale.value, {
        monthsShort: $i18n.t('app.date.monthsShort').split('_'),
        months: $i18n.t('app.date.monthsGenitive').split('_'),
        meridiem: (hour) => {
          return hour >= 12
            ? $i18n.t('app.date.ampm').split('_')[1]
            : $i18n.t('app.date.ampm').split('_')[0]
        },
      })

      $dayjs.locale(locale.value)
    }

    // обновляем текущую локаль
    dayjsUpdateLocale($i18n.locale)

    $i18n.beforeLanguageSwitch = (oldLocale, newLocale) => {
      const { dayjsLocale } = $i18n.locales.value.find(
        ({ code }) => code === newLocale,
      )

      dayjsUpdateLocale(dayjsLocale)
    }

    $gaApp.i18n = {
      locale: $i18n.localeProperties,
      locales: $i18n.locales,
      t: $i18n.t.bind({ $i18n }),
      te: $i18n.te.bind({ $i18n }),
      tm: $i18n.tm.bind({ $i18n }),
      // tc: $i18n.tc.bind({ $i18n: $i18n }),
      // d: $i18n.d.bind({ $i18n: $i18n }),
      // te: $i18n.te.bind({ $i18n: $i18n }),
      // n: $i18n.$n.bind({ $i18n: $i18n }),
      setLocaleCookie: $i18n.setLocaleCookie.bind({ $i18n }),
      switchLocalePath: $switchLocalePath,
    }
  },
)
